<template>
  <div>
    <p class="text-primary"> {{inscripciones.length}} inscripciones.</p>
    <button v-show="inscripciones.length > 0" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')"> <span class="glyphicon glyphicon-print"></span> Generar Reporte EXCEL </button>

    <div class="table-responsive">
      <table class="table table-condensed table-striped">
        <thead>
          <tr>
            <th>Nro</th>
            <th>Estudiante</th>
            <th>Saldo General</th>
            <th>Matricula</th>
            <th>Cuota del Anterior Mes</th>
            <th>Cuota del Mes</th>
            <th>Cuota Vigente</th>
            <th>Nro Cuota</th>
            <th>Matricula</th>
            
            <th>Telefono</th>
            <th>Asesor</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="i.id" v-for="(i,ind) in inscripciones" @click="detalleInscripcion(i.id)" data-toggle="modal" data-target="#modal">
            <td> {{ind+1}} </td>
            <!-- <td> {{i.estado_ins}} </td> -->
            <td>{{parseEstudiante(i.estudiante)}} </td>
            <td> {{getSaldoGeneral(i.cuotas_por_pagar)}} </td>
            <td> {{getMontoMatricula(i.matricula)}} </td>
            <td> {{getCuotaDeudas(i.cuotas_por_pagar,2)}} </td>
            <td> {{getCuotaDeudas(i.cuotas_por_pagar,1)}} </td>
            <td> {{getCuotaDeudas(i.cuotas_por_pagar,0)}} </td>
            <td> {{getNumerosCuota(i.cuotas_por_pagar)}} </td>
            <td> {{getSaldoMatricula(i.matricula)}} </td>

            <td> {{getTelefono(i.estudiante)}} </td>
            <td> {{parseEstudiante(i.asesor)}} </td>
          </tr>
        </tbody>
      </table>
      <small> {{preinstr}} </small>
    </div>

    <Plan id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Plan from '@/components/ADetallePlanPagos.vue'
import {parseJsonError} from '@/components/Utils.js'

export default {
  props:{ programa:{type:Object,required:true},mes:Object },
  data(){ 
    return{
      // EXCEL 
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
      // END EXCEL
      seleccionado: {xid:-1,xtitle:'X',xbody:'X',xsql:null},
      inscripciones: [],
      preinstr: '',
    }
  },
  components:{Plan},
  watch:{
    'programa':function(){
      this.mes.idmes = {}
      this.inscripciones = [];
      this.preinstr = "";
     },
    'mes.idmes':function(){
      if( this.mes == null ) return;
      if( this.mes.idmes.id ) this.getInscripciones()
     },
  },
  methods:{
    tableToExcel(table, name){
      if (!table.nodeType) table = this.$refs.table
      var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
      var link = document.createElement("a");
      link.download = "asignaciones.xls";
      link.href = this.uri + this.base64(this.format(this.template, ctx));
      link.click();
    },
    fechaPasada( fecha,salto ){
      var f1 = new Date( fecha );
      var f2 = new Date();
      f2.setMonth( this.mes.idmes.id-1 );
      f2.setMonth( f2.getMonth()-salto );
      if( salto == 1 ){
        var f3 = new Date();
        f3.setMonth( this.mes.idmes.id-1 );
        f3.setMonth( f3.getMonth()-(salto+1) );
        if( (f1 < f2) && (f1 > f3) ) return true;
        else return false;
      }
      //window.console.log( "VERIF:  ",salto,f1,"\n",f2,"\n\n",(f1<f2) );
      if( f1 < f2 ){
        //window.console.log( "VERIF:  ",f1,"\n",f2,"\n\n",(f1<f2) );
        return true;
      }
      return false;
    },
    parseEstudiante( e ){
      if( e==null ) return "";
      return e.nombres+" "+e.pri_apellido;
    },
    getTelefono( e ){
      if( e==null ) return "";
      return e.telefono1;
    },
    getSaldoGeneral( porpagar ){
      var monto = 0;
      porpagar.forEach( function(e){
        monto += e.monto;
      })
      return monto;
    },
    getMontoMatricula( m ){
      if( m == null) return -1;
      return m.monto;
    },
    getSaldoMatricula( m ){
      if( m == null) return -1;
      return m.saldo;
    },
    getCuotaAnteriorMes( porpagar,meses ){
      var monto = 0;
      var vue = this;
      porpagar.forEach( function(e){
        var v = vue.fechaPasada( e.fecha,meses );
        if( v ) monto += e.saldo;
      });
      return monto;
    },
    getCuotaMes( porpagar,meses ){
      var monto = 0;
      var vue = this;
      porpagar.forEach( function(e){
        var v = vue.fechaPasada( e.fecha,meses );
        if( v ) monto = e.saldo;
      });
      return monto;
    },
    getCuotaDeudas( porpagar,meses ){
      //window.console.log( "\n\n\n\n-",porpagar );
      var monto = 0;
      if( meses == 2 ) monto = this.getCuotaAnteriorMes( porpagar,meses );
      else if( meses == 1 ) monto = this.getCuotaMes( porpagar,meses );
      else{
        var an = this.getCuotaAnteriorMes( porpagar,2 );
        var me = this.getCuotaMes( porpagar,1 );
        monto = an +me;
      }
      return monto;
    },
    getNumerosCuota( porpagar ){
      var cuotas = '';
      var vue = this;
      porpagar.forEach( function(e){
        var v = vue.fechaPasada( e.fecha,0 );
        if( v ) cuotas += e.nro_cuota+', ';
      });
      cuotas = cuotas.trim();
      if( cuotas.length > 0 ) cuotas = cuotas.substring(0,cuotas.length-1);
      return cuotas;
    },
    detalleInscripcion( id ){
      window.console.log( "ID INSC: ",id );
      var msg = "Plan de pagos";
      var body = "El postgrado sera cambiado.";
      var tag = gql`
      query{
        getInscripcion(id:${id}){
          estado_ins
          estudiante{nombres,pri_apellido}
          asesor{nombres,pri_apellido}
          monto_matricula,monto_colegiatura,monto_certificacion,cuotas,
          cuotas_canceladas{monto,saldo,fecha,nro_cuota,pagos{monto,saldo,fecha_pago,nro_recibo}}
          cuotas_por_pagar{monto,saldo,fecha,nro_cuota,pagos{monto,saldo,fecha_pago,nro_recibo}}
        }
      }
      `;
      this.seleccionado = {xid:12,xtitle:msg,xbody:body,xsql:tag}
    },
    modalExito(){},

    async getInscripciones(){
      if( this.programa.id == null ) return;
      var idprograma = this.programa.id;
      var vue = this;
      var sql = gql`
      query{
        getPrograma(id:${idprograma}){
          inscripciones{
            id
            estado_ins
            programa{id,version,gestion, postgrado{nombre,categoria{nombre}}}
            estudiante{nombres,pri_apellido,seg_apellido,telefono1}
            asesor{nombres,pri_apellido}
            matricula{monto,saldo,pagos{monto,saldo,nro_recibo}}
            cuotas_por_pagar{monto,saldo,fecha,nro_cuota,pagos{monto,saldo,nro_recibo}}
            cuotas_canceladas{monto,saldo,fecha,pagos{monto,saldo,nro_recibo}}
            cuotas_desechadas{monto,saldo,fecha,pagos{monto,saldo,nro_recibo}}
          }
        }
      }
      `;
      window.console.log( "ASIGNACIONES",sql )
      await this.$apollo.query({
        query: sql,
      }).then((data) => {
          var ins = data.data.getPrograma.inscripciones; 
          var total1 = ins.length;
          ins = ins.filter(function(e){ return e.estado_ins>0 });
          vue.inscripciones = ins;
          var total2 = vue.inscripciones.length;
          var preins = total1 - total2;
          this.preinstr = "Preinscritos: "+preins;
          window.console.error("ASIG: ",total1,total2,preins);
      }).catch((error) => {
          window.console.error(error)
          this.$notify( parseJsonError( error,'getPrograma' ) )
      })
    }
  },
  mounted(){
    this.getInscripciones();
  }
}
</script>